<template>
  <structure-list ref="share_modal" id="share_modal" :bauhof-structure="possibleShares"
                  :multi-select="true" :is-share="true" @on-selected="onShare" @on-forward-open="onForwardOpen" @hidden="hidden"/>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {encryptAES} from "@/shared/crypto";
import StructureList from "@/views/lists/StructureList.vue";

export default {
  name: "task_messaging_share",
  props: {
    taskShort: Object,
    showShare: Boolean,
  },
  components: {
    StructureList,
  },
  data() {
    return {
      showModal: false,
      possibleShares: [],
      sharedUsers: [],
      selectedShares: null,
      loader: undefined,
      myUser: "",
    }
  },
  watch: {
    showShare: function(newVal, oldVal) { // watch it
        if (newVal) {
          this.onShow();
          this.showModal = true;
        } else {
          this.showModal = newVal;
        }
    }
  },
  mounted() {
    this.myUser = this.$cookies.get("ps_user_id");
  },
  methods: {
    hidden() {
      this.$emit("hidden")
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    async onShare({ids, message}) {
      let data = JSON.stringify(this.taskShort);
      ids.push(this.$cookies.get("ps_user_id"));
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));

      let messageInit = me.full_name + " hat eine Aufgabe weitergeleitet";
      messageInit = await encryptAES(sessionStorage.getItem("aes"), messageInit);
      data = await encryptAES(sessionStorage.getItem("aes"), data);
      let messageBonus = message;
      if (message !== "") {
        messageBonus = await encryptAES(sessionStorage.getItem("aes"), messageBonus);
      }
      let req = {
        room_name: "WG: " + this.taskShort.title,
        participants: ids,
        initial_message: messageInit,
        task_id: this.taskShort.id,
        task_payload: data,
        message_bonus: messageBonus,
      }
      let response;
      try {
        response = await this.$http.post(
            Server_URL + '/auftragsbuch/messaging/forward?web=true', req
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
      this.$emit("share-success", response.body)
    },
    async onForwardOpen(userId) {
      let response;
      try {
        response = await this.$http.get(
            Server_URL + '/auftragsbuch/messaging/forwards?task_id='+this.taskShort.id+"&user_id="+userId
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
      this.$emit("forward-open-success", response.body)
    },

    async onShow() {
      let response;
      this.showLoader();
      try {
        response = await this.$http.get(
            Server_URL + '/auftragsbuch/messaging/contacts?task_id=' + this.taskShort.id
        )
      } catch (e) {
        this.hideLoader();
        this.responseError(e)
        return
      }
      this.hideLoader();
      let data = response.body.users;
      let selection = [];
      this.selectedShares = null;
      this.possibleShares = response.body.users;
      this.$refs.share_modal.showModal();
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  },
}
</script>

<style scoped>

</style>
